import React, {useState, useEffect, useRef, useContext} from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronDown } from 'lucide-react'
import { UserSettingsContext } from '../../../context/UserSettingsContext';

const SelectColumnBox = ({onAccountClick}) => {
    const [showSubColumns, setShowSubColumns] = useState(true);
    const [selectedColumn, setSelectedColumn] = useState(null);
    const { selectableAccounts } = useContext(UserSettingsContext);
    const subColumns = {
        popularColumns: selectableAccounts.filter((account) => (account.category_1.category==='often_used'  && account.col !== 'stock_price')),
        marketColumns: selectableAccounts.filter((account) => (account.category_1.category==='market' && account.col !== 'stock_price')),
        plSelections: selectableAccounts.filter((account) => account.category_1.category==='pl'),
        bsSelections: selectableAccounts.filter((account) => account.category_1.category==='bs'),
        cfSelections: selectableAccounts.filter((account) => account.category_1.category==='cf'),
        ratioSelections: selectableAccounts.filter((account) => account.category_1.category==='indicator'),
    }

    const showSubColumnBox = (columnName, explanation) => {
        setShowSubColumns(true);
        setSelectedColumn({ columnName: columnName, explanation, explanation });
    }
    
    const SubColumnBox = ({column}) => {
        if (!column) { return <></> }
        return (
            <div className="column-selections">
                <div className='category'>{column.explanation}</div>
                <ul>
                    {subColumns[column.columnName].map((col) => (
                        <li key={col.col} onClick={() => onAccountClick(col)}>{col.col_name}</li>
                    ))}
                </ul>
            </div>
        )
    }

       return (
        <div className="absolute top-[55px] bg-[#F5F5F4] p-5 rounded-lg w-[500px] flex z-[2000]">
            <div className="categories">
                <div className="category">カテゴリ</div>
                <ul>
                    <li  onClick={()=>showSubColumnBox('popularColumns', 'よく利用される項目')}><i className="fa-solid fa-fire"></i>よく利用される項目</li>
                    <li  onClick={()=>showSubColumnBox('marketColumns', 'マーケット')}><i className="fa-solid fa-fire"></i>マーケット</li>
                    <li  onClick={()=>showSubColumnBox('plSelections', '損益')}><i className="fa-solid fa-chart-gantt"></i>損益</li>
                    <li  onClick={()=>showSubColumnBox('bsSelections', '財政')}><i className="fa-solid fa-coins"></i>財政</li>
                    <li  onClick={()=>showSubColumnBox('cfSelections', 'キャッシュフロー')}><i className="fa-solid fa-meteor"></i>キャッシュフロー</li>
                    <li  onClick={()=>showSubColumnBox('ratioSelections', '指標')}><i className="fa-solid fa-calculator"></i>比率</li>
                </ul>
            </div>
            {showSubColumns && <SubColumnBox column={selectedColumn} />}
        </div>
    )
}


const SelectScatterColumnContainer = ({selectedAccount, setSelectedAccount}) => {
    const [showSelectBox, setShowSelectBox] = useState(false);
    const containerRef = useRef(null);
    const [displayAccount, setDisplayAccount] = useState(selectedAccount?.col_name);

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setShowSelectBox(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.preventDefault();
            setShowSelectBox(false);
        }
    };

    const onAccountClick = (account) => {
        setSelectedAccount(account)
        setDisplayAccount(account.col_name);
        setShowSelectBox(false);
    }

    return (
        <div className="summary-graph-selected-column-container w-[200px]">
            <div className="column-container">
                <div className="summary-graph-search-company-input column-input w-full" ref={containerRef}>
                    <button
                        onClick={() => setShowSelectBox(!showSelectBox)}
                        className="relative w-full px-4 py-2 text-left bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent"
                    >
                        <span className="block truncate">{selectedAccount.col_name}</span>
                        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <motion.div
                                animate={{ rotate: showSelectBox ? 180 : 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <ChevronDown className="w-5 h-5 text-gray-400" aria-hidden="true" />
                            </motion.div>
                        </span>
                    </button>
                    {showSelectBox && <SelectColumnBox onAccountClick={onAccountClick} />}
                </div>
            </div>
        </div>
    );
};    

export default SelectScatterColumnContainer;